import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { GlobalService } from '../services/index.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingInterceptor implements HttpInterceptor {

constructor(
  private router:Router,
  private global:GlobalService,
) { }
  intercept(request: HttpRequest<any> , next: HttpHandler): Observable<HttpEvent<any>>{
    return next.handle(request).pipe(
      catchError((error : HttpErrorResponse) => {
        const errorMassage = this.setError(error);
        return throwError(errorMassage)
      })
    );
  }
  setError(error:HttpErrorResponse){
    let errorMassage:string | number = 0;
    if(error.error instanceof ErrorEvent){
      errorMassage = error.error.message;
    }else{
      if(error.status){
        errorMassage = error.error;
        return error
      }
    }
    
    return errorMassage;
  }
}